import { useLocation } from 'react-router-dom'

export function useIsLaunch() {
	const { state } = useLocation()
	return Boolean(state?.launchCampaignDialog)
}
